import {jsonMember, jsonObject} from "typedjson";

@jsonObject
export class DxNciDictionaryItem {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _id: number;

  @jsonMember({name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _parentId: number;

  @jsonMember({name: "ident", constructor: String, emitDefaultValue: false, isRequired: false })
  protected _ident: string;

  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  protected _name: string;

  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false })
  protected _ord: number = 0;

  @jsonMember({name: "startDate", constructor: Date, emitDefaultValue: false, isRequired: false })
  private _startDate: Date;

  @jsonMember({name: "endDate", constructor: Date, emitDefaultValue: false, isRequired: false })
  private _endDate: Date;


  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get parentId(): number {
    return this._parentId;
  }

  set parentId(value: number) {
    this._parentId = value;
  }

  get ident(): string {
    return this._ident;
  }

  set ident(value: string) {
    this._ident = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get startDate(): Date {
    return this._startDate;
  }

  set startDate(value: Date) {
    this._startDate = value;
  }

  get endDate(): Date {
    return this._endDate;
  }

  set endDate(value: Date) {
    this._endDate = value;
  }
}
